<template>
  <div class="check-orders-component">
    <div class="check-orders-component__content">
        <div class="check-orders-component__header">
          <div class="check-orders-component__order-wrapper">
            <div class="check-orders-component__order-title">
              Номер заказа:
            </div>
            <div class="check-orders-component__order">
              {{ info.order }}
            </div>
          </div>
          <div
              class="check-orders-component__status"
              :style="`
                color: ${checkColor};
               `"
          >
            {{ getStatus }}
          </div>
        </div>

        <div class="check-orders-component__line">

        </div>

        <div class="check-orders-component__date-info">
          <div class="check-orders-component__date">
            <div class="check-orders-component__date-title">
              Дата и время показа:
            </div>
            <div class="check-orders-component__date-value">
              {{ bknDate }}.{{ bknMonth }}.{{ bknYear }} |
              {{ bknHours }}:{{ bknMinutes }}
            </div>
          </div>
          <div class="check-orders-component__price">
            <div class="check-orders-component__price-title">
              Цена:
            </div>
            <div class="check-orders-component__price-value">
              {{ info.price }} ₽
            </div>
          </div>
        </div>

        <div class="check-orders-component__info-cancel" v-if="info.state === 'отменен'">
          В ближайшее время с вами свяжется менеджер по вопросу возврата денежных средств.
        </div>

        <div
            class="check-orders-component__link"
            v-if="info.state === 'отменен'"
            @click="$router.push('/return-policy')"
        >
          <span>Условия возврата</span>
        </div>

        <div class="check-orders-component__moderation-info" v-if="info.state === 'одобрен с корректировками'">
          Текст поздравления был отредактирован модератором.
        </div>

        <div class="check-orders-component__moderation-info" v-if="info.state === 'одобрен с корректировками'">
          Просим обратить внимание, что если вы не подтвердили правки в течение суток, заказ не будет отправлен, деньги в таком случае не возвращаются.
        </div>

        <div class="check-orders-component__moderation-changes-wrapper">
          <div
              v-if="info.state === 'одобрен с корректировками' && info.changes.length > 0"
              v-for="(item, index) in info.changes"
              class="check-orders-component__moderation-changes"
          >
            <div class="check-orders-component__moderation-changes-title">
              Блок {{ index + 1 }}
            </div>

            <div
                v-for="(text, i) in item"
                class="check-orders-component__moderation-changes-text"
            >
              <div
                  v-for="(sym, k) in text"
                  :style="`
                  text-transform: ${k === 0 ? 'uppercase' : 'none'};
                  min-width: 5px;
                  color: ${checkChangeText({ obj: item, indexObj: i, indexSymb: k, sym: sym })}
                `"
              >
                {{sym}}
              </div>
            </div>

            <div class="check-orders-component__moderation-changes-line"></div>
          </div>
        </div>

        <div
            @click="$emit('setOrder', {
              info: info,
              status: 'confirm'
            })"
            class="check-orders-component__button-cancel"
            style="color: #2FAF1A; margin-top: 24px"
            v-if="info.state === 'одобрен с корректировками'"
        >
          Согласен с изменениями
        </div>

        <div
            class="check-orders-component__button-cancel"
            style="margin-top: 8px"
            v-if="info.state === 'одобрен с корректировками'"
            @click="$emit('setOrder', {
              info: info,
              status: 'cancel'
            })"
        >
          Не согласен, отменить заказ

        </div>

        <div class="check-orders-component__new-counter" v-if="(info.state === 'подтвержден' || info.state === 'одобрен') && is_timer">
          <div class="check-orders-component__new-counter-numbers">
            <div class="check-orders-component__new-counter-one-number">
              {{days[0]}}
            </div>
            <div class="check-orders-component__new-counter-one-number">
              {{days[1]}}
            </div>

            <span>
              :
            </span>

            <div class="check-orders-component__new-counter-one-number">
              {{hours[0]}}
            </div>
            <div class="check-orders-component__new-counter-one-number">
              {{hours[1]}}
            </div>

            <span>
              :
            </span>

            <div class="check-orders-component__new-counter-one-number">
              {{minutes[0]}}
            </div>
            <div class="check-orders-component__new-counter-one-number">
              {{minutes[1]}}
            </div>

            <span>
              :
            </span>

            <div class="check-orders-component__new-counter-one-number">
              {{seconds[0]}}
            </div>
            <div class="check-orders-component__new-counter-one-number">
              {{seconds[1]}}
            </div>
          </div>

          <div class="check-orders-component__new-counter-text">
            До показа: {{ date_text.days.value }} {{ date_text.days.text }}, {{ date_text.hours.value }} {{ date_text.hours.text }}, {{ date_text.minutes.value }} {{ date_text.minutes.text }}, {{ date_text.seconds.value }} {{ date_text.seconds.text }}
          </div>
        </div>

        <div
            @click="$emit('setOrder', {
              info: info,
              status: 'cancel'
            })"
            class="check-orders-component__button-cancel"
            v-if="(info.state === 'подтвержден' || info.state === 'одобрен') && is_timer"
        >
          Отменить заказ
        </div>
    </div>
  </div>
</template>

<script>

import check_order_get_date from "@/views/check_order/modules/check_order_get_date";

export default {
  async mounted() {
    check_order_get_date(this, new Date(this.info.timestamp - this.timezone))
  },
  props: {
    info: {
      default: () => {}
    }
  },
  data() {
    return {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
      interval: false,
      is_timer: false,
      date_text: {
        days: {
          value: 0,
          text: ''
        },
        hours: {
          value: 0,
          text: ''
        },
        minutes: {
          value: 0,
          text: ''
        },
        seconds: {
          value: 0,
          text: ''
        }
      },
      total: 0
    }
  },
  computed: {
    timezone() {
      return (-new Date().getTimezoneOffset() * 60) * 1000
    },
    resultDate() {
      return new Date(this.info.timestamp - this.timezone)
    },
    bknDate() {
      return this.resultDate.getDate() >= 10 ? String(this.resultDate.getDate()) : String(`0${this.resultDate.getDate()}`)
    },
    bknMonth() {
      return (this.resultDate.getMonth() + 1) >= 10 ? String(this.resultDate.getMonth() + 1) : String(`0${(this.resultDate.getMonth() + 1)}`)
    },
    bknYear() {
      return String(this.resultDate.getFullYear())
    },
    bknHours() {
      return this.resultDate.getHours() >= 10 ? String(this.resultDate.getHours()) : String(`0${this.resultDate.getHours()}`)
    },
    bknMinutes() {
      return this.resultDate.getMinutes() >= 10 ? String(this.resultDate.getMinutes()) : String(`0${this.resultDate.getMinutes()}`)
    },
    getStatus() {
      if(this.info.state === 'одобрен с корректировками'){
        return 'Одобрен с корректировками'
      } else if(this.info.state === 'модерация') {
        return 'На модерации'
      } else if(this.info.state === 'отменен') {
        return 'Отменен'
      } else if(this.info.state === 'ожидает оплату') {
        return 'Ожидает оплату'
      } else if(this.info.state === 'подтвержден') {
        return 'Подтвержден'
      } else if(this.info.state === 'одобрен') {
        return 'Одобрен'
      } else if(this.info.state === 'отменен пользователем') {
        return 'Отменен пользователем'
      } else if(this.info.state === 'отменен администратором') {
        return 'Отменен модератором'
      } else if(this.info.state === 'просрочен') {
        return 'Просрочен'
      }
    },
    checkColor() {
      if(this.info.state === 'одобрен с корректировками') {
        return '#FFD84F'
      } else if(this.info.state === 'модерация') {
        return '#FFD84F'
      } else if(this.info.state === 'отменен'
          || this.info.state === 'просрочен'
          || this.info.state === 'отменен пользователем'
          || this.info.state === 'отменен администратором') {
        return '#FF3A45'
      } else if(this.info.state === 'ожидает оплату') {
        return '#FFD84F'
      } else if(this.info.state === 'подтвержден') {
        return '#3BC026'
      } else if(this.info.state === 'одобрен') {
        return '#3BC026'
      }
    },
  },
  methods: {
    checkChangeText({ obj, indexObj, indexSymb, sym}) {
      if(indexObj === 0) {
        return obj[1][indexSymb] === sym ? '#FFFFFF': '#FF3A45'
      } else {
        return obj[0][indexSymb] === sym ? '#FFFFFF' : '#2FAF1A'
      }
    },
    declination(number, txt, cases = [2, 0, 1, 1, 1, 2]) {
      return txt[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
    }
  }
}
</script>

<style lang="less">
  .check-orders-component {
    width: 100%;
    padding: 0px 16px;
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
  .check-orders-component__content {
    width: 343px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 5px;
    padding: 12px 12px;
  }

  .check-orders-component__header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .check-orders-component__order-wrapper {
    display: flex;
    flex-direction: column;
  }

  @import '~/assets/fonts/roboto/Roboto-Light.less';

  .check-orders-component__order-title,
  .check-orders-component__date-title,
  .check-orders-component__price-title,
  .check-orders-component__counter-title,
  .check-orders-component__moderation-changes-title {
    font-size: 13px;
    color: #ACAFBE;
    font-family: 'Roboto-Light';
    margin-bottom: 3px;
  }

  .check-orders-component__moderation-changes-text {
    font-family: 'Roboto-Light';
    font-size: 15px;
    color: #FFFFFF;
    display: flex;
  }

  @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

  .check-orders-component__order {
    font-size: 15px;
    color: #FFFFFF;
    font-family: 'Roboto-Medium';
  }

  @import '~/assets/fonts/roboto/Roboto-Medium.less';

  .check-orders-component__status {
    font-size: 15px;
    font-family: 'Roboto-Medium';
    color: #3BC026;
    max-width: 146px;
    text-align: end;
  }

  .check-orders-component__status::first-letter,
  .check-orders-component__moderation-changes-text::first-letter{
    text-transform: uppercase;
  }

  .check-orders-component__line,
  .check-orders-component__moderation-changes-line {
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.3);
    margin-top: 8px;
  }

  .check-orders-component__date-info,
  .check-orders-component__counter {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .check-orders-component__counter {
    align-items: center;
  }

  .check-orders-component__date,
  .check-orders-component__price {
    display: flex;
    flex-direction: column;
  }

  .check-orders-component__price {
    align-items: flex-end;
  }

  .check-orders-component__date-value,
  .check-orders-component__price-value,
  .check-orders-component__counter-value {
    color: #FFFFFF;
    font-size: 15px;
    font-family: 'Roboto-Medium';
  }

  .check-orders-component__new-counter {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    align-items: center;
  }

  .check-orders-component__new-counter-numbers {
    display: flex;
    align-items: center;
  }

  .check-orders-component__new-counter-numbers span {
    font-size: 22px;
    color: #FFFFFF;
    margin-bottom: 2px;
    margin-right: 4px;
  }

  .check-orders-component__new-counter-one-number {
    width: 26px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-size: 19px;
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.15);
    margin-right: 4px;
  }

  .check-orders-component__new-counter-text {
    color: #ACAFBE;
    font-size: 13px;
    font-family: 'Roboto-Light';
    max-width: 200px;
    text-align: center;
    margin-top: 12px;
  }

  .check-orders-component__link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    font-size: 15px;
    font-family: 'Roboto-Light';
    margin-top: 20px;
    cursor: pointer;
  }

  .check-orders-component__link span {
    border-bottom: 1px dashed #FFFFFF;
  }

  .check-orders-component__info-cancel {
    font-size: 15px;
    font-family: 'Roboto-Light';
    color: #ACAFBE;
    margin-top: 28px;
  }

  .check-orders-component__moderation-info {
    font-family: 'Roboto-Light';
    font-size: 13px;
    color: #ACAFBE;
    margin-top: 16px;
  }

  .check-orders-component__moderation-changes {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 14px;
  }

  .check-orders-component__moderation-changes:last-child .check-orders-component__moderation-changes-line {
    display: none;
  }

  .check-orders-component__counter-value {
    font-size: 22px;
  }

  .check-orders-component__button-cancel {
    width: 100%;
    height: 44px;
    border-radius: 5px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FF3A45;
    font-family: 'Montserrat-Medium';
    margin-top: 30px;
    cursor: pointer;
  }

</style>